import { Grid, makeStyles } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { withSnackbar } from 'notistack';
import React, { useState } from 'react';
import DocumentPreview from '../../../components/DocumentPreview';
import Preview from '../../../components/Preview';
import DataTable from '../../../toolkit/DataTable/DataTable';
import ListDataProvider from '../../../toolkit/mobx-connectors/ListDataProvider';
import { fetchPdfAsBase64 } from '../../../utils/form-utils';
import DataView from '../../components/DataView';
import ContainerDataView from './ContainerDataView';
import facturasConfig from './FacturasConfig';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3)
  },
  container: {
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      padding: 0
    }
  },
  img: {
    width: '150px',
    [theme.breakpoints.down('sm')]: {
      width: '100px'
    }
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.short
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  tableCellAction: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  button: {
    margin: 0,
    textDecoration: 'none',
    marginLeft: theme.spacing(1)
  },
  addButon: {
    padding: '15px'
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  iconSmall: {
    fontSize: 20
  },

  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  cardStyle: {
    borderRadius: '4px 4px 0px 0px'
  },
  tableContainerItem: {
    overflowX: 'auto',
    paddingBottom: theme.spacing(2)
  }
}));

const FacturasView = ({ values, isPhone, ...props }) => {
  const classes = useStyles();
  const { enqueueSnackbar } = props;
  const [pdfPreview, setPdfPreview] = useState();
  const [imagePreview, setImagePreview] = useState();

  // const onPdfView = value => {
  //   if (value?.factura && value.factura[0]) {
  //     const file = value.factura[0];
  //     const url = URL.createObjectURL(file);
  //     setPdfPreview({ url, title: file.name });
  //   } else {
  //     enqueueSnackbar('No se pudo cargar la factura', {
  //       variant: 'warning'
  //     });
  //   }
  // };

  const onPdfView = async value => {
    try {
      setPdfPreview({
        url: '',
        title: 'Factura EF'
      });
      setImagePreview({
        url: '',
        title: 'Factura EF',
        open: false
      });
      const url = await fetchPdfAsBase64(
        `${process.env.REACT_APP_ROOT_API}factura/${value.id}/descargar`
      );

      if (url.startsWith('data:application/pdf')) {
        setPdfPreview({
          url,
          title: `Factura EF ${value.nroFactura}`,
          download: `factura-${value.id}`
        });
      } else {
        setImagePreview({
          url,
          title: `Factura EF ${value.nroFactura}`,
          download: `factura-${value.id}`,
          open: true
        });
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar('No se pudo cargar la factura', {
        variant: 'warning'
      });
    }
  };

  const configuraciones = facturasConfig({
    classes,
    enqueueSnackbar,
    onPdfView
  });
  const dataset = 'facturas';

  const { datosConfig } = configuraciones[dataset];
  const { datosSettings } = configuraciones[dataset];

  const onReloadTable = () => {
    const pageSize = props.factura.list?.pagingData?.pageSize || 10;
    const currentPage = props.factura.list?.pagingData?.currentPage || 0;
    props.factura.list.dataLoaded(
      values.facturas.slice(
        currentPage * pageSize,
        currentPage * pageSize + pageSize
      ),
      {
        currentPage,
        pageSize,
        itemsCount: values.facturas.length
      }
    );
  };

  return (
    <>
      <ContainerDataView title="Facturas">
        <Grid container spacing={1} className={classes.tableContainerItem}>
          <Grid item xs={12}>
            <DataView
              label="Moneda"
              value={values.descripcionMoneda || ''}
              isPhone={isPhone}
            />
          </Grid>
          {values.facturas && (
            <Grid item>
              <ListDataProvider
                listStore={props.factura.list}
                render={listProps => (
                  <DataTable
                    title={datosConfig.titulo}
                    disableReload
                    settings={datosSettings}
                    onReloadTable={() => onReloadTable()}
                    fileName={datosConfig.servicio}
                    {...listProps}
                  />
                )}
              />
            </Grid>
          )}

          {pdfPreview && (
            <DocumentPreview
              title={pdfPreview.title}
              file={pdfPreview.url}
              download={pdfPreview.download}
              onClose={() => {
                setPdfPreview();
              }}
            />
          )}
          {imagePreview && (
            <Preview
              title={imagePreview.title}
              open={imagePreview.open}
              download={imagePreview.download}
              onClose={() => {
                setImagePreview({ open: false });
              }}
            >
              <img src={imagePreview.url} alt="vista previa" />
            </Preview>
          )}
        </Grid>
      </ContainerDataView>
    </>
  );
};

export default inject('factura')(observer(withSnackbar(FacturasView)));
